import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import styleVars from '../design-system/scss-vars';
import { selectSimpleAttributeIcon } from '../selectors/attributes-icon';

const RoundelAttributeIcon = ({ id }) => {
  const Icon = selectSimpleAttributeIcon(id);

  return (
    <div
      className="ss_pos--center"
      css={css`
        width: 145px;
        height: 145px;
        margin: auto;
        border-radius: 50%;
        border: 2px solid ${styleVars.ssPrimaryDark};`
      }
    >
      <Icon
        color={styleVars.ssSecondary}
        css={css`
          display: block;
          width: 100px;
          height: 100px;`
        }
      />
    </div>
  );
};

RoundelAttributeIcon.propTypes = {
  id: PropTypes.string.isRequired,
};

export default RoundelAttributeIcon;
